<template>
  <div v-if="showBanner" class="bottle">
    <a class="close" href="#" @click="setForceHideFreeBottleBanner(true)" />

    <div class="bottle-inner">
      <div class="prescription">{{ $t('home.free_bottle_banner.prescription') }}</div>
      <div class="title">{{ $t('home.free_bottle_banner.title') }}</div>
      <div class="description">{{ $t('home.free_bottle_banner.description') }}</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { AUTH_IS_LOGGED_IN, GENERAL_FORCE_HIDE_FREE_BOTTLE_BANNER, USER_PROFILE } from '@/store/types.getters'
import { GENERAL_SET_FORCE_HIDE_FREE_BOTTLE_BANNER } from '@/store/types.mutations'

export default {
  name: 'FreeBottleBanner',
  computed: {
    showBanner () {
      const isLoggedIn = this.$store.getters[AUTH_IS_LOGGED_IN]
      const profile = this.$store.getters[USER_PROFILE]
      const forceHideFreeBottleBanner = this.$store.getters[GENERAL_FORCE_HIDE_FREE_BOTTLE_BANNER]

      if (isLoggedIn && !forceHideFreeBottleBanner && profile && !profile.receivedFreeBottle) {
        return true
      }

      return false
    }
  },
  methods: {
    ...mapMutations({
      setForceHideFreeBottleBanner: GENERAL_SET_FORCE_HIDE_FREE_BOTTLE_BANNER
    })
  }
}
</script>
